import { render, staticRenderFns } from "./CheckListView.vue?vue&type=template&id=4d5157b1&scoped=true&"
import script from "./CheckListView.vue?vue&type=script&lang=js&"
export * from "./CheckListView.vue?vue&type=script&lang=js&"
import style0 from "./CheckListView.vue?vue&type=style&index=0&id=4d5157b1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5157b1",
  null
  
)

export default component.exports